import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Root from './root';
import './index.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <Suspense fallback='loading'>
      <Root />
    </Suspense>
  </StrictMode>
);
